import { LazyAction, LazyModule } from 'owa-bundling';
import { runAfterSessionData } from 'owa-delayed-initialization';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MessageOptions", webpackPrefetch: true */ './lazyIndex')
);

export let lazyLoadSignatureInUserOptions = new LazyAction(
    lazyModule,
    m => m.loadSignatureInUserOptions
);

// The signature needs to be written into user options
// which has to happen after session data
runAfterSessionData(() => {
    lazyLoadSignatureInUserOptions.importAndExecute();
});
